import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { authService } from "../../services/authService"; // adjust path if different

const isAdminUser = (u) =>
  !!u && (u.role === "admin" || u.role === "superadmin" || u.isAdmin === true);

export default function AdminRoute({ children }) {
  const location = useLocation();

  // Read from localStorage via your authService
  const user = authService.getCurrentUser(); // { id, email, name, role, isAdmin, ... } or null

  if (!user) {
    // not logged in -> go to login
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  if (!isAdminUser(user)) {
    // logged in but not admin -> redirect (home or a 403 page)
    return <Navigate to="/" replace />;
  }

  return children;
}
